<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#ffffff"
    >
      <sidebar-item v-for="route in routes" :key="route.name" :item="route" :base-path="route.path"></sidebar-item>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  name: 'AppSidebar',
  components: { SidebarItem },
  props: {
    routes: {
      type: Array,
      default() {
        return []
      }
    },
    logoPath: {
      type: String,
      default: '/actor/list'
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    // routes() {
    //   return this.$router.options.routes.filter(r => r.admin)
    // },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style lang="scss">
.system-title {
  display: flex;
  align-items: center;
  // padding: 16px;
  text-align: center;
  vertical-align: middle;
  // line-height: 50px;
  background-color: #fff;
  color: #000;
  font-weight: bold;
  font-size: 14px;

  &:hover {
    color: #000;
  }
}
.hideSidebar .system-title {
  display: none !important;
}
</style>
